import "./App.css";
import keypads from "./keypad-data.json";

/* ---------- header ---------- */
function Header() {
  const updated = "22 May 2025, 19:25";

  return (
    <header className="site-header">
      <img
        className="logo"
        src={
          "https://s3websitedata.s3.amazonaws.com/profile/newOrganization/jg-construction-london/778453-Parkview_Mezzanine.jpeg"
        }
        alt="Sync Design Technologies logo"
      />
      <div className="project-meta" style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
        <h1>
          <span>Ordnance&nbsp;Hill – Socket&nbsp;&amp;&nbsp;Keypad&nbsp;Schedule</span>
        </h1>
        <p className="description">
          <span>Low-voltage lighting keypad and socket configuration for the private residence.</span>
        </p>
        <time dateTime={new Date().toISOString()}>
          <span>Last updated: {updated}</span>
        </time>
      </div>
    </header>
  );
}

/* ---------- socket plate ---------- */
function SocketPanel({ plate }) {
  // flatten the `buttons` array so we get max six labels
  const labels = plate.buttons.flatMap((b) => [b.left, b.right]).slice(0, 6);
  
  // SVG icons for indicators
  const svgIcons = [
    // Single dot
    <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" className="icon-indicator">
      <circle cx="6" cy="6" r="3" fill="#3b82f6" />
    </svg>,
    
        // Arrow up (A)
        <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" className="icon-indicator">
        <polygon points="6,2 10,10 2,10" fill="#3b82f6" />
      </svg>,
      
    // Two dots
    <svg width="16" height="12" xmlns="http://www.w3.org/2000/svg" className="icon-indicator">
      <circle cx="4" cy="6" r="2.5" fill="#3b82f6" />
      <circle cx="12" cy="6" r="2.5" fill="#3b82f6" />
    </svg>,
    
        // Arrow down (V)
        <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" className="icon-indicator">
        <polygon points="6,10 10,2 2,2" fill="#3b82f6" />
      </svg>,
      
    // Three dots
    <svg width="20" height="12" xmlns="http://www.w3.org/2000/svg" className="icon-indicator">
      <circle cx="3" cy="6" r="2" fill="#3b82f6" />
      <circle cx="10" cy="6" r="2" fill="#3b82f6" />
      <circle cx="17" cy="6" r="2" fill="#3b82f6" />
    </svg>,
    


    // Hollow circle (O)
    <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" className="icon-indicator">
      <circle cx="6" cy="6" r="4" stroke="#3b82f6" stroke-width="1.5" fill="none" />
    </svg>
  ];

  return (
    <section className="keypad">
      {/* Re-use the same card styling (.keypad) for consistency */}
      <h3>{plate.name}</h3>

      <div className="socket-panel">
        <div className="button-grid">
          {labels.map((text, i) => (
            <div key={i} className="panel-button">
              <div className="button-content">
                {svgIcons[i]}
                <div className="button-text">{text || "\u00A0"}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


/* ---------- footer ---------- */
function Footer() {
  return (
    <footer className="site-footer">
      <p>
        © {new Date().getFullYear()} Ordnance Hill Project • All information is
        indicative and may be subject to change.
      </p>
      <p>
        Built&nbsp;by{" "}
        <a
          href="https://www.syncdesign.tech/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Sync&nbsp;Design&nbsp;Technologies
        </a>
      </p>
      <a
        href="https://www.syncdesign.tech/"
        target="_blank"
        rel="noopener noreferrer"
        className="bitdesign-logo-link"
      >
        <img
          src="https://s3websitedata.s3.eu-west-2.amazonaws.com/logos/bitdesing+logo-01.png"
          alt="BitDesign Logo"
          className="bitdesign-logo"
          style={{ maxHeight: "40px", maxWidth: "40px" }}
        />
      </a>
    </footer>
  );
}

/* ---------- existing components (styling only changed in CSS) ---------- */
function Rocker({ label }) {
  if (!label) return <div className="rocker empty" />;
  return (
    <div className="rocker" title={label}>
      <span>{label}</span>
    </div>
  );
}

function SwitchRow({ left, right }) {
  return (
    <div className="switch-row">
      <Rocker label={left} />
      <Rocker label={right} />
    </div>
  );
}

function Keypad({ pad }) {
  return (
    <section className="keypad">
      <h3>{pad.name}</h3>
      {pad.buttons.map((b, i) => (
        <SwitchRow key={i} left={b.left} right={b.right} />
      ))}
    </section>
  );
}

/* ---------- root ---------- */
export default function App() {
  return (
    <>
      <Header />
      <main className="App">
        {keypads.map((record) =>
          record.type !== "socket" ? (
            <SocketPanel key={record.name} plate={record} />
          ) : (
            <Keypad key={record.name} pad={record} />
          )
        )}
      </main>
      <Footer />
    </>
  );
}
